import { create } from 'zustand';
import type { MeDTO, ShopSessionResponse, StaffMember } from '@/types/api';

interface AuthState {
  user: MeDTO | null;
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated';

  // Two-step login staging. `shopSession` is populated after step 1
  // (POST /shop/login); `selectedStaff` is set when the cashier taps their
  // card to open the PIN pad. Both clear on a successful PIN login or an
  // explicit "back to shop" from the UI.
  shopSession: ShopSessionResponse | null;
  selectedStaff: StaffMember | null;

  setUser: (user: MeDTO | null) => void;
  setStatus: (status: AuthState['status']) => void;
  setShopSession: (s: ShopSessionResponse) => void;
  clearShopSession: () => void;
  setSelectedStaff: (s: StaffMember | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  shopSession: null,
  selectedStaff: null,
  setUser: (user) => set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
  setShopSession: (s) => set({ shopSession: s, selectedStaff: null }),
  clearShopSession: () => set({ shopSession: null, selectedStaff: null }),
  setSelectedStaff: (s) => set({ selectedStaff: s }),
  logout: () =>
    set({ user: null, status: 'unauthenticated', shopSession: null, selectedStaff: null }),
}));
